import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import ErrorView from "~components/Error";
import Page from "../../../Common/Page";
import { LoadingState, NoAccessView, SelectStartupItem } from "../components";
import type { StartupItem } from "../types/startupItem";
import { useFetchCustomers } from "./hooks";
import { transformCustomer } from "./utilities";

const SelectCustomerPage = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const { data, isLoading, error } = useFetchCustomers();
  const customerList = data || [];

  const transformedCustomers = useMemo<StartupItem[]>(() => {
    let filteredCustomers = customerList;
    if (searchText) {
      filteredCustomers = customerList.filter(({ displayName }) => displayName.toLowerCase().includes(searchText.toLowerCase()));
    }

    return filteredCustomers.map(transformCustomer);
  }, [searchText, customerList]);

  const handleSelectCustomer = (id) => navigate(`/${id}/select/organization/`);

  if (isLoading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorView
        titleIntlKey="error.unexpected"
        descriptionIntlKey="error.unexpected.customers.description"
        actionButtonIntlKey="try.again"
        Icon={ExclamationCircleOutlined}
        onActionButtonClick={() => window.location.reload()}
        details={JSON.stringify(error)}
      />
    );
  }

  if (customerList.length === 0) {
    return <NoAccessView intlMessageId="customers.noAccess" />;
  }

  return (
    <Page
      showBackButton={false}
      title={<FormattedMessage id="pageTitles.selectCustomer" />}
      subtitle={<FormattedMessage id="customers.available" />}
    >
      <SelectStartupItem
        handleSelect={handleSelectCustomer}
        searchText={searchText}
        setSearchText={setSearchText}
        startupItemList={transformedCustomers}
      />
    </Page>
  );
};

export default SelectCustomerPage;
